// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../../base/types.js';
import { default as _Exchange } from '../../base/PredictionExchange.js';

interface Exchange {
    limitlessPublicGetMarketsActive (params?: {}): Promise<Dict>;
    limitlessPublicGetMarketsActiveCategoryId (params?: {}): Promise<Dict>;
    limitlessPublicGetCategories (params?: {}): Promise<List>;
    limitlessPublicGetMarketsAddressOrSlug (params?: {}): Promise<Dict>;
    limitlessPublicGetMarketsCategoriesCount (params?: {}): Promise<Dict>;
    limitlessPublicGetMarketsActiveSlugs (params?: {}): Promise<List>;
    limitlessPublicGetMarketsSearch (params?: {}): Promise<Dict>;
    limitlessPublicGetMarketsSlugOrderbook (params?: {}): Promise<Dict>;
    limitlessPublicGetMarketsSlugHistoricalPrice (params?: {}): Promise<Dict>;
    limitlessPublicGetAuthSigningMessage (params?: {}): Promise<string>;
    limitlessPublicGetMarketsAddressOrSlugOracleCandles (params?: {}): Promise<Dict>;
    limitlessPublicGetMarketsSlugGetFeedEvents (params?: {}): Promise<Dict>;
    limitlessPublicGetMarketsSlugEvents (params?: {}): Promise<Dict>;
    limitlessPublicGetMarketsTimeline (params?: {}): Promise<Dict>;
    limitlessPublicGetMarketsSlugTimeline (params?: {}): Promise<Dict>;
    limitlessPublicGetNavigation (params?: {}): Promise<List>;
    limitlessPublicGetMarketPagesByPath (params?: {}): Promise<Dict>;
    limitlessPublicGetMarketPagesIdMarkets (params?: {}): Promise<Dict>;
    limitlessPublicGetPropertyKeys (params?: {}): Promise<List>;
    limitlessPublicGetPropertyKeysId (params?: {}): Promise<Dict>;
    limitlessPublicGetPropertyKeysIdOptions (params?: {}): Promise<List>;
    limitlessPublicGetPortfolioAccountTradedVolume (params?: {}): Promise<Dict>;
    limitlessPublicGetPortfolioAccountPositions (params?: {}): Promise<Dict>;
    limitlessPublicGetPortfolioAccountPnlChart (params?: {}): Promise<Dict>;
    limitlessPrivateGetAuthApiKeys (params?: {}): Promise<Dict>;
    limitlessPrivateGetProfilesPartnerAccounts (params?: {}): Promise<Dict>;
    limitlessPrivateGetMarketsSlugUserOrders (params?: {}): Promise<List>;
    limitlessPrivateGetPortfolioPositions (params?: {}): Promise<Dict>;
    limitlessPrivateGetPortfolioTrades (params?: {}): Promise<Dict>;
    limitlessPrivateGetMarketsSlugLockedBalance (params?: {}): Promise<Dict>;
    limitlessPrivateGetProfilesMe (params?: {}): Promise<Dict>;
    limitlessPrivateGetProfilesAccount (params?: {}): Promise<Dict>;
    limitlessPrivateGetPortfolioPnlChart (params?: {}): Promise<Dict>;
    limitlessPrivateGetPortfolioHistory (params?: {}): Promise<Dict>;
    limitlessPrivateGetPortfolioPoints (params?: {}): Promise<Dict>;
    limitlessPrivateGetPortfolioTradingAllowance (params?: {}): Promise<Dict>;
    limitlessPrivateGetAuthApiTokensCapabilities (params?: {}): Promise<Dict>;
    limitlessPrivateGetAuthApiTokens (params?: {}): Promise<List>;
    limitlessPrivateGetProfilesPartnerAccountsProfileIdAllowances (params?: {}): Promise<Dict>;
    limitlessPrivatePostAuthLogout (params?: {}): Promise<Dict>;
    limitlessPrivatePostAuthApiKeys (params?: {}): Promise<Dict>;
    limitlessPrivatePostAuthLogin (params?: {}): Promise<Dict>;
    limitlessPrivatePostOrders (params?: {}): Promise<Dict>;
    limitlessPrivatePostOrdersCancel (params?: {}): Promise<Dict>;
    limitlessPrivatePostOrdersCancelBatch (params?: {}): Promise<Dict>;
    limitlessPrivatePostOrdersBatchCancel (params?: {}): Promise<Dict>;
    limitlessPrivatePostOrdersStatusBatch (params?: {}): Promise<Dict>;
    limitlessPrivatePostPortfolioRedeem (params?: {}): Promise<Dict>;
    limitlessPrivatePostPortfolioWithdraw (params?: {}): Promise<Dict>;
    limitlessPrivatePostPortfolioWithdrawalAddresses (params?: {}): Promise<Dict>;
    limitlessPrivatePostAuthApiTokensDerive (params?: {}): Promise<Dict>;
    limitlessPrivatePostProfilesPartnerAccounts (params?: {}): Promise<Dict>;
    limitlessPrivatePostProfilesPartnerAccountsProfileIdAllowancesRetry (params?: {}): Promise<Dict>;
    limitlessPrivateDeleteAuthApiKeys (params?: {}): Promise<Dict>;
    limitlessPrivateDeleteOrdersOrderId (params?: {}): Promise<Dict>;
    limitlessPrivateDeleteOrdersAllSlug (params?: {}): Promise<Dict>;
    limitlessPrivateDeleteAuthApiTokensTokenId (params?: {}): Promise<Dict>;
    limitlessPrivateDeletePortfolioWithdrawalAddressesAddress (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
